import { Box, FormLabel, Link, Stack } from '@mui/material';
import { useState } from 'react';

import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import { FSPositionGeocodeField } from '@/ui/components/input/FSPositionGeocodeField';
import { FSTextField } from '@/ui/components/input/FSTextField';
import { translate } from '@/ui/i18n';

export function EventPositionField({
  label,
  eventPositionName,
  overridePosition,
  onOverridePositionChange,
}: {
  label: string;
  eventPositionName: string | undefined;
  overridePosition: PositionGeocode | undefined;
  onOverridePositionChange: (position: PositionGeocode | undefined) => void;
}) {
  const [isOverriding, setIsOverriding] = useState(!!overridePosition);

  const startOverriding = () => {
    setIsOverriding(true);
  };

  const stopOverriding = () => {
    setIsOverriding(false);
    onOverridePositionChange(undefined);
  };

  return (
    <Box sx={{ width: '20rem', flexShrink: 0 }}>
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
        <FormLabel sx={{ fontSize: '0.8rem' }}>{label}</FormLabel>
        <OverrideToggleLink
          isOverriding={isOverriding}
          onStartOverriding={startOverriding}
          onStopOverriding={stopOverriding}
        />
      </Stack>
      {isOverriding ? (
        <FSPositionGeocodeField
          value={overridePosition}
          onChange={(position) =>
            onOverridePositionChange(position ?? undefined)
          }
          size="small"
        />
      ) : (
        <FSTextField disabled value={eventPositionName} size="small" />
      )}
    </Box>
  );
}

function OverrideToggleLink({
  isOverriding,
  onStartOverriding,
  onStopOverriding,
}: {
  isOverriding: boolean;
  onStartOverriding: () => void;
  onStopOverriding: () => void;
}) {
  if (isOverriding) {
    return (
      <Link
        component="button"
        type="button"
        onClick={onStopOverriding}
        sx={{ fontSize: '0.7rem' }}
      >
        {translate('ProjectsTour.TourTravelForm.use-event-location')}
      </Link>
    );
  }

  return (
    <Link
      component="button"
      type="button"
      onClick={onStartOverriding}
      sx={{ fontSize: '0.7rem' }}
    >
      {translate('ProjectsTour.TourTravelForm.specify-another-location')}
    </Link>
  );
}
